<router-outlet></router-outlet>

<!-- <div>
    <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
        <p class="text-white m-0 p-0">Loading...</p>
    </ngx-spinner>
</div> -->
